module.exports = __webpack_public_path__ + "static/img/real-time.789142c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/real-time.png
// module id = bPxp
// module chunks = 1